module.exports = __webpack_public_path__ + "img/a298dca50afa1ad9274a28b1eff8df44.png";